import { Flex, Spinner, useColorMode } from '@chakra-ui/react'
import Apex from 'react-apexcharts'

export default function SalesChart({ data, title, description, ...props }){

    const { colorMode } = useColorMode()

    const dates = data?.map(item => item.base_date)
    const values = data?.map(item => item.sales)

    const series = [
        {
            name: 'Vendas',
            data: values
        }
    ]

    const options = {
        theme: { 
            mode: colorMode,
            palette: 'palette9'
        },
        title: {
            text: title,
            align: 'center'
        },
        subtitle: {
            text: description,
            align: 'center'
        },
        chart: { 
            height: 350, 
            type: 'area', 
            background: 'transparent',
            locales: [require('apexcharts/dist/locales/pt.json')],
            defaultLocale: 'pt',
            foreColor: 'orange',
            zoom: { 
                enabled: true 
            }, 
            animations: { 
                enabled: true, 
                easing: 'easeinout', 
                animateGradually: {
                    enabled: true,
                    delay: 150 
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 350
                }
            } 
        },
        dataLabels: { 
            enabled: false 
        },
        stroke: { 
            curve: 'smooth'
        },
        grid: { 
            show: false 
        },
        xaxis: { 
            type: 'datetime', 
            categories: dates 
        },
        tooltip: { 
            x: { 
                format: 'dd/MM/yy' 
            }, 
        }
    }

    // Loading state
    if(!data) return <Flex w="100%" h={350} alignItems="center" justifyContent="center"><Spinner /></Flex>

    // Chart
    return <Apex options={options} series={series} type="area" height={350} />
}